import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "342",
  "slug": "equal-earth-projection-replacing-mercator",
  "title": "The Equal Earth Projection: Comparing Areas on a World Map",
  "excerpt": "An equal-area projection designed for world maps, with its own shape and distance trade-offs.",
  "date": "2026-06-04",
  "category": "Geography",
  "image": "https://images.unsplash.com/photo-1524661135-423995f22d0b?ixid=M3w5NjY4NzN8MHwxfHNlYXJjaHwxfHx3b3JsZCUyMG1hcCUyMGF0bGFzfGVufDF8MHx8fDE3ODA1NjA0NzN8MA&ixlib=rb-4.1.0&w=800&q=80&fit=crop",
  "readTime": "1 min",
  "author": "EarthGuessr Team",
  "content": [
    {
      "type": "paragraph",
      "text": "Equal Earth is an equal-area world map projection developed in 2018 by Bojan Šavrič, Tom Patterson, and Bernhard Jenny. It preserves relative areas while giving the world a rounded outline. That makes it useful when the question concerns how much surface a region occupies."
    },
    {
      "type": "heading",
      "text": "What it preserves"
    },
    {
      "type": "paragraph",
      "text": "If one mapped region has twice the area of another on Earth, it occupies twice the area on an Equal Earth map using the same area convention. Shapes and distances still change. Equal-area does not mean that every measurement you make with a ruler is valid."
    },
    {
      "type": "heading",
      "text": "A different job from Mercator"
    },
    {
      "type": "paragraph",
      "text": "Mercator's local angle preservation and straight constant-bearing lines serve different tasks. Equal Earth offers an alternative for area comparisons; its existence does not mean every navigation map should switch to it. Nor does a handful of adoptions establish that it is replacing Mercator everywhere."
    },
    {
      "type": "paragraph",
      "text": "For a comparison, use the same geographic data in both projections. Look at a high-latitude region and an equatorial one, then check the size relationship. Keep colours and labels unchanged so the projection is the variable you are examining."
    }
  ],
  "sources": [
    {
      "title": "Equal Earth creators: projection and original paper",
      "url": "https://equal-earth.com/equal-earth-projection.html"
    },
    {
      "title": "PROJ: Equal Earth projection documentation",
      "url": "https://proj.org/en/stable/operations/projections/eqearth.html"
    }
  ],
  "relatedSlugs": [
    "mercator-projection-why-your-map-lies",
    "map-projections-explained-beyond-mercator"
  ]
};
